import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FlowLanguageService {

  constructor() { }

  parse(definition: any) {

    let actions = [];

    this.visit(definition, [], (key, value, path)=>{

      if (value instanceof Object) {
        const { type, inputs } = value;
        const { apiId, connectionName, operationId } = inputs?.host || {};

        if (apiId == '/providers/Microsoft.PowerApps/apis/shared_approvals') {
          if (operationId == 'StartAndWaitForAnApproval' || operationId == 'WaitForAnApproval' || operationId == 'StartAndWaitForATextSuggestionApproval') {
            // create approval
            actions.push({
              key,
              value
            });
          }
        }
      }

    });

    return actions;
  }

  visit(definition: any, path: string[], visitor: (key: string, value: any, path: string[])=>void, returner: (key: string, value: any, path: string[])=>void = null) {

    if (definition == null) {
      return;
    }
    for(const [key, value] of Object.entries(definition) as [string,any]) {
      if (key == "$schema") {
        continue;
      }
      if (value == null) {
        continue;
      }  
      visitor(key, value, path);
      if (value instanceof Object){
        this.visit(value, [...path, key], visitor, returner);
        // if (more && more.length) {
        //   result.push(...more);
        // }
        returner?.(key, value, path);
        continue;
      } 
      else {
        returner?.(key, value, path);
      }
    }
  }

}
